<template>
    <div class="join--wrapper">
        <main-header></main-header>
        <featured-roles></featured-roles>
        <about></about>
        <testimony></testimony>
        <perks-grid></perks-grid>
        <our-offices></our-offices>
        <living-czech></living-czech>
        <video-banner></video-banner>
        <apply-now id="apply"></apply-now>

    </div>

</template>

<script>
    import MainHeader from "../components/landingPageComponents/MainHeader";
    import ApplyNow from "../components/ApplyNow";
    import About from "../components/landingPageComponents/AboutUs";
    import PerksGrid from "../components/landingPageComponents/PerksGrid";
    import OurOffices from "../components/landingPageComponents/OurOffices";
    import VideoBanner from "../components/VideoBanner";
    import LivingCzech from "../components/landingPageComponents/livingCzech";
    import Testimony from "../components/landingPageComponents/Testimony";
    import PositionsSlider from "../components/sliders/JobsPositionsSlider";
    import ContainerWithOffset from '../components/common/ContainerWithOffset'
    import FeaturedRoles from "../components/common/FeaturedRolesHomePage";


    export default {
        name: "JoinPage",
        components: {
          FeaturedRoles,
            PositionsSlider,
            Testimony,
            LivingCzech,
            VideoBanner,
            OurOffices,
            PerksGrid,
            About,
            ApplyNow,
            MainHeader,
            ContainerWithOffset
        },

    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../assets/scss/globals";

    .join--wrapper {
        max-width: 100%;
        max-height: 100%;
    }


</style>



// WEBPACK FOOTER //
// src/pages/JoinPage.vue